import React, { useEffect } from "react";

const InstagramConnect = () => {
  useEffect(() => {
    (async function () {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const state = params.get("state");

      const body = document.getElementById("insta-body");

      if (!code) {
        if (body) body.innerHTML = "<p style='color:red'>Missing code in callback.</p>";
        return;
      }

      try {
        const resp = await fetch("https://admin.xder.app:4000/exchange_code", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code, state }),
        });

        const data = await resp.json();

        if (resp.ok && data.success) {
          if (body) body.innerHTML = "<p>Instagram connected successfully!</p>";
          // Optionally redirect
          // window.location = '/dashboard';
        } else {
          if (body)
            body.innerHTML = `<p style='color:red'>Failed: ${data.message}</p>`;
        }
      } catch (err) {
        if (body)
          body.innerHTML = `<p style='color:red'>Network Error: ${err.message}</p>`;
      }
    })();
  }, []);

  return (
    <div id="insta-body">
      <p>Connecting your Instagram... please wait</p>
    </div>
  );
};

export default InstagramConnect;
